






















































































































import {ApplicationUserModel, PartyWorkDayModel, WorkTaskModel, WorkTaskStatementModel} from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';
import { WorkTaskDialogItemModel } from '../model/WorkTaskDialogItemModel';
import WorkTaskRuleDialog from '@/libs/parties/components/WorkTaskRuleDialog.vue';
import { clone, cloneDeep, isEqual } from 'lodash';
import {authStore} from "@/libs/auth/+store/store";
import {AuthGetter} from "@/libs/auth/models/auth-state";

@Component({
    components: {
        WorkTaskRuleDialog
    }
})
export default class WorkTaskDialogItem extends Page {

    emptyId = Guid.EmptyGuid();
    itemOriginal: WorkTaskDialogItemModel | null = null;

    @VModel() item!: WorkTaskDialogItemModel;
    @Prop() index!: number;
    @Prop() partyId!: string;
    @Prop() partyWorkDay!: PartyWorkDayModel | null;
    @Prop({ default: false }) readonly!: boolean;

    @Ref() workTaskRuleDialog!: WorkTaskRuleDialog;
    
    get partyCareProviders(): string[] {
        const userInfo = authStore.useGetter(AuthGetter.GetUserInfo);
        return this.partyWorkDay!.partyWorkDayUsers!.select(x => x.userId!).toArray().concat([ userInfo.sub ]).toArray();
    }

    mounted () {
        if (this.itemOriginal == null)
            this.itemOriginal = cloneDeep(this.item);
    }

    addStatementClick () {
        this.item.workTaskStatements!.push({
            id: Guid.EmptyGuid(),
            workTaskId: this.item.id,
            visitNumber: 1,
            amount: undefined
        } as WorkTaskStatementModel);
        this.checkChange();
    }

    openWorkTaskRule () {
        if (this.item.workTaskRuleId)
            this.workTaskRuleDialog.open(this.item.workTaskRuleId, this.partyId, true);
    }

    checkChange () {
        if (!isEqual(this.item, this.itemOriginal)) {
            if (this.item.id == this.itemOriginal!.id) {
                this.$emit("change");
            } else {
                this.itemOriginal = cloneDeep(this.item);
            }
        }
    }

	isAnyStatementLockedByBilling(item: WorkTaskModel) {
			return item.workTaskStatements?.any(x => x.billing?.isLocked == true) ?? false;
	}

	isStatementLockedByBilling(statement: WorkTaskStatementModel) {
			return statement.billing?.isLocked == true;
	}

}
